import '../style/main.css';
import Meta from '../components/Meta.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import founderImg from '../resources/founders.jpg';
import roseGarden from '../resources/rose-garden2.png';

function OurStory() {
  return (
		<>
			<Meta title='Our Story'/>
			<Header />
			<div class='main-content'>
				<h2>Our Story</h2>
				<p>
					Borealis Blades Historical Fencing was founded in 2017. 
					Joe Van Ert, Autumn Eule-Nashoba, and Kevin Granzow had all practiced HEMA before moving to the Duluth area. 
					Joe and Autumn had trained together at the Minnesota Sword Club in Minneapolis, 
					studying mainly German Kunst des Fechtens (KDF) traditions for many years. 
					Kevin had training on the East Coast and was excited to keep training after moving to the frigid North. 
					Kevin also studied early KDF sources. After meeting up over a beer, 
					they decided that forming their own club to keep practicing KDF would have to happen. Together, 
					the three worked to form the non-profit that we now call Borealis Blades Historical Fencing.
				</p>
				<br />
				<div class='img-right' style={{maxWidth: '75%'}}>
					<img class='main-img' src={founderImg} />
					<sub><i>From left to right: Kevin Granzow, Joe Van Ert, Autumn Eule-Nashoba</i></sub>
				</div>
				<p>	
					To keep the club focused on a singular idea, 
					we created a common club goal. That common goal is “Get more people, doing more HEMA.” 
					To accomplish this goal, our club has strived to be inclusive to all people and has an openness to try HEMA outside of our normal KDF traditions. 
					We have also tried to make it as easy and cheap as possible for people to start their HEMA journey. 
					When making club decisions, we always ask ourselves if this will help more people do more types of HEMA, 
					and that process has helped guide us in a positive direction.
				</p>
				<br />
				<div class='img-right' style={{maxWidth: '40%'}}>
					<img class='main-img' src={roseGarden} />
				</div>
				<p>
					Borealis Blades is part of a larger HEMA community called the <a href='https://www.hemaalliance.com/'>HEMA Alliance</a>, or HEMAA for short. 
					The HEMAA is a non-profit in the USA that helps non-profit clubs purchase insurance. 
					This helps us remain low-cost by allowing hundreds of clubs around the USA to purchase this insurance together. 
					The first two months of practice at Borealis Blades are completely free. 
					After those first two months, members will need to become members of the HEMAA, 
					which currently costs $30 a year per person. 
					This is the only charge you will have when practicing with Borealis Blades. 
					We would rather your money go to you purchasing HEMA gear than going into our bank account.
					<br /><br />
					Over the years, we have changed locations where we practice in the twin ports, 
					and we suspect that will continue as we grow as a group. 
					One thing that won't change is the fact that we get to fence in one of the most beautiful places in all of MN. 
					Please <a href='/join'>reach out to us and come practice with us</a> in these beautiful places. 
					Let us help you find your own sword person journey.
				</p>
			</div>
			<Footer />  
		</>
	);
};

export default OurStory;
